exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4d2742f4] .el-dialog__body{max-height:650px;overflow:auto}\n", ""]);

// exports
